"use client";

// ── Simple markdown renderer (no external dep) ─────────────────────
// Handles: bold, italic, inline-code, links, headings, ordered/unordered
// lists, fenced code blocks, paragraphs, blank lines.
// Styles via the global `.bw-md` class (globals.css).
export function MarkdownBlock({ content }: { content: string }) {
  function render(text: string): string {
    const lines = text.split("\n");
    const out: string[] = [];
    let inCode = false;
    for (const raw of lines) {
      if (raw.startsWith("```")) {
        inCode = !inCode;
        out.push(inCode ? '<pre><code>' : '</code></pre>');
        continue;
      }
      if (inCode) { out.push(esc(raw)); continue; }
      const line = raw;
      // Headings
      if (/^### /.test(line)) { out.push(`<h3>${inline(line.slice(4))}</h3>`); continue; }
      if (/^## /.test(line)) { out.push(`<h2>${inline(line.slice(3))}</h2>`); continue; }
      if (/^# /.test(line)) { out.push(`<h1>${inline(line.slice(2))}</h1>`); continue; }
      // Horizontal rule — must test before list bullets (* would match --- as bold)
      if (/^(---+|\*\*\*+|___+)$/.test(line.trim())) { out.push('<hr>'); continue; }
      // Lists
      if (/^[-*] /.test(line)) { out.push(`<li>${inline(line.slice(2))}</li>`); continue; }
      if (/^\d+\. /.test(line)) { out.push(`<li>${inline(line.replace(/^\d+\. /, ''))}</li>`); continue; }
      // Blank line
      if (line.trim() === '') { out.push('<br>'); continue; }
      out.push(`<p>${inline(line)}</p>`);
    }
    return out.join('\n');
  }

  function inline(s: string): string {
    return s
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/`(.+?)`/g, '<code>$1</code>')
      .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
  }

  function esc(s: string): string {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  return (
    <div
      className="bw-md"
      dangerouslySetInnerHTML={{ __html: render(content) }}
    />
  );
}
